import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';

import { map } from 'lodash';
import { LinearProgress, Paper, Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui';
import Pagination from '../../shared/Pagination';

const columnStyle = {
  whiteSpace: 'normal',
  paddingRight: 0,
  paddingLeft: 0,
  border: '1px groove',
  width: 40,
};
const VacationTable = ({ entries, table }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [dataSource, setDataSource] = useState([]);

  const { loading } = useSelector(state => state.vacationApprovalsReducer);

  useEffect(() => {
    setDataSource(entries);
  }, [entries]);
  const getCell = (request) => {
    const styleBase = {
      color: 'white',
      border: 'none',
      borderRadius: 0,
      width: '100%',
      height: '100%',
      display: 'flex',
      boxShadow: 'none',
      justifyContent: 'center',
      background: 'white',
    };
    return (
      <span style={{ ...styleBase, background: request.color }} />
    );
  };
  return (
    <Paper style={{ maxWidth: 1600, margin: 'auto' }}>
      {loading && <LinearProgress mode="indeterminate" />}
      <Pagination
        data={dataSource}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      >
        {currentData => (
          <div style={{
            overflowX: 'auto', maxWidth: '100%',
          }}
          >
            <Table
              className="vacation-table"
              bodyStyle={{ overflowX: 'none', overflowY: 'none', minHeight: 520 }}
              fixedHeader
            >
              <TableHeader
                displaySelectAll={false}
                adjustForCheckbox={false}
                enableSelectAll={false}
              >
                <TableRow key="table-key" hoverable>
                  {map(table.columns, (c, i) => (
                    // eslint-disable-next-line no-nested-ternary
                    <TableHeaderColumn key={i} style={{ ...columnStyle }} className={i === 0 ? 'sticky-column' : (c.isRedDay || c.isWeekend) ? 'weekend-column' : ''}>
                      {c.title}
                    </TableHeaderColumn>
                  ))}
                </TableRow>
              </TableHeader>
              <TableBody
                displayRowCheckbox={false}
                deselectOnClickaway={false}
                showRowHover
                stripedRows={false}
              >
                {!loading ? map(currentData, (row, index) => (
                  <TableRow key={index} displayBorder>(
                    {map(table.columns, (c, i) => (
                      <TableRowColumn
                        key={i}
                        style={{
                          ...columnStyle,
                        }}
                        // eslint-disable-next-line no-nested-ternary
                        className={i === 0 ? 'sticky-column' : (c.isRedDay || c.isWeekend) ? 'weekend-column' : ''}
                      >
                        {c.render ? c.render(row[c.dataIndex]) : row[c.dataIndex]}
                        {row.approvalRequests[c.dataIndex] ? getCell(row.approvalRequests[c.dataIndex]) : null}
                      </TableRowColumn>
                    ))})
                  </TableRow>
                )) : null}
              </TableBody>
            </Table>
          </div>
        )}
      </Pagination>
    </Paper>
  );
};

VacationTable.propTypes = {
  table: PropTypes.shape({
    columns: PropTypes.array.isRequired,
    key: PropTypes.string.isRequired,
  }).isRequired,
  entries: PropTypes.array.isRequired,
};

export default connect()(VacationTable);



// WEBPACK FOOTER //
// ./src/sites/vacationApprovals/VacationTable.js